export enum EMaoLegType {
  Training = 'Training',
  Maintenance = 'Maintenance',
  'Empty to Donor' = 'Empty to Donor',
  'Team To Donor' = 'Team To Donor',
  'Positioning P91' = 'Positioning P91',
  'Positioning P135' = 'Positioning P135',
  Charter = 'Charter',
  'Team to Hub' = 'Team to Hub',
  'Empty to Recipient' = 'Empty to Recipient',
  'Donor to Recipient' = 'Donor to Recipient',
  'Empty to Hub Repo' = 'Empty to Hub Repo',
  'Device to Hub' = 'Device to Hub',
}
